import * as React from 'react';
import { Grid, Chip, Button, Menu, MenuItem, Typography } from "@material-ui/core";
import { withStyles } from '@material-ui/core/styles';
import AddIcon from '@material-ui/icons/Add';

const ITEM_HEIGHT = 48;

const styles = () => ({
  smallButton: {
    height: 36,
    width: 36
  },
});


interface IProps {
  classes: any
  itemOptions: any[]
  items: any[]
  labelProperty?: string
  label?: string
  disabled?: boolean
  disbaleDoubles?: boolean
  handleDeleteItem(item: any): void
  handleAddItem(item: any): void
}

interface IState {
  anchorEl: HTMLElement | undefined
}

class EditableChipList extends React.Component<IProps, IState> {
  constructor(props: any) {
    super(props);
    this.state = {
      anchorEl: undefined
    }
  }

  public handleCloseMenue = (item?: any) => {
    if (item) {
      this.setState({ anchorEl: undefined }, () => this.props.handleAddItem(item))
    }
    else {
      this.setState({ anchorEl: undefined })
    }
  };

  public itemLabel = (item: any) => {
    if (this.props.labelProperty && item[this.props.labelProperty]) {
      return item[this.props.labelProperty]
    }
    else {
      return item
    }
  }

  public handleOpenMenueClick = (event: any) => {
    this.setState({ anchorEl: event.currentTarget })
  };

  public render() {
    const filteredItemOptions = this.props.itemOptions.filter(itemOption => {
      for (const item of this.props.items) {
        if (item.id === itemOption.id && this.props.disbaleDoubles) {
          return false
        }
      }
      return true

    });
    return (
      <Grid container={true} spacing={8} alignItems='center'>
        {this.props.label ?
          <Grid item={true}>
            <div style={{
              minWidth: 55,
              borderRight: '1px solid #ccc',
              paddingRight: 8
            }
            }>
              <Typography variant="caption" align="right" >{this.props.label}</Typography>
            </div>
          </Grid> : null}
        {this.props.items.map((item, index) =>
          <Grid item={true} key={index}>
            {!this.props.disabled &&
              <Chip
                label={this.itemLabel(item)}
                onDelete={() => this.props.handleDeleteItem(item)}
              />
            }
            {this.props.disabled &&
              <Chip
                label={this.itemLabel(item)}
              />
            }
          </Grid>
        )}
        {this.props.disabled && this.props.items.length < 1 &&
          <Grid>
            <div className="padding-8">
              <Typography variant="caption">none</Typography>
            </div>
          </Grid>
        }
        {!this.props.disabled && filteredItemOptions.length > 0 &&
          <Grid item={true}>
            <Button
              variant="fab"
              mini={true}
              color="secondary"
              aria-label="Add"
              onClick={this.handleOpenMenueClick}
              aria-owns={this.state.anchorEl ? 'long-menu' : undefined}
              aria-haspopup="true"
              className={this.props.classes.smallButton}
            >
              <AddIcon />
            </Button>
            <Menu
              id="long-menu"
              anchorEl={this.state.anchorEl}
              open={Boolean(this.state.anchorEl)}
              onClose={() => this.handleCloseMenue()}
              PaperProps={{
                style: {
                  maxHeight: ITEM_HEIGHT * 4.5,
                  width: 200,
                },
              }}
            >
              {filteredItemOptions.map((item, index) => (
                <MenuItem key={index} onClick={() => this.handleCloseMenue(item)}>
                  {this.itemLabel(item)}
                </MenuItem>
              ))}
            </Menu>
          </Grid>
        }
      </Grid>
    )
  }
}

export default withStyles(styles)(EditableChipList)


// WEBPACK FOOTER //
// ./src/modules/shared/components/EditableChipList.tsx